function ErrorState({ message }) {
  return (
    <div className="error-state">
      <h3>Something went wrong</h3>
      <p>{message || 'Failed to load content. Please try again later.'}</p>
    </div>
  );
}

export default ErrorState;
